import React from 'react';
import * as antd from 'antd';

const Pagination = ({ meta, navigate }) => {
	return (
		<React.Fragment>
			<antd.Pagination
				className="mt-4"
				total={meta.total || 0}
				pageSize={meta.limit || 0}
				current={meta.page || 0}
				onChange={(e) => {
					e && navigate(`${(e - 1) * meta.limit || 0}-${meta.limit || 0}`);
				}}
				showSizeChanger={false}
				itemRender={(_, type, originalEele) => {
					if (type === 'prev') {
						return (
							<div>
								<p className="pagination-next px-3 rounded pointer">Previous</p>
							</div>
						);
					}
					if (type === 'next') {
						return (
							<div>
								<p className="pagination-next px-3 rounded pointer">Next</p>
							</div>
						);
					}
					return originalEele;
				}}
			/>
		</React.Fragment>
	);
};

export default Pagination;
